var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { ApplicationsService } from 'app/applications/applications.service';
import { WebApi } from 'app/core/web-api.service';
import { concat } from 'rxjs';
import { tap, toArray } from 'rxjs/operators';
import { ServiceType } from '../core/service-type.model';
import { UserSettingsService } from './user-settings.service';
var Account = /** @class */ (function () {
    function Account(account, paymentInfo, applications) {
        // see: https://tfs/Cloud/FlexiCapture/_workitems/edit/6183
        this.allowDataCapture = true;
        this.allowInvoiceCapture = true;
        this.currency = paymentInfo.currency;
        this.id = account.id;
        this.paymentType = paymentInfo.type;
    }
    return Account;
}());
export { Account };
var AccountService = /** @class */ (function () {
    function AccountService(_applicationsService, _userSettingsService, _webApi) {
        this._applicationsService = _applicationsService;
        this._userSettingsService = _userSettingsService;
        this._webApi = _webApi;
    }
    AccountService.prototype.init = function () {
        var _this = this;
        return concat(this._webApi.getOnce('/v1/account'), this._webApi.getOnce('/v1/account/paymentInfo'), this._applicationsService.init())
            .pipe(toArray(), tap(function (_a) {
            var _b = __read(_a, 3), account = _b[0], paymentInfo = _b[1], applications = _b[2];
            _this.account = new Account(account, paymentInfo, applications);
            if (!_this.account.allowInvoiceCapture) {
                _this._userSettingsService.serviceType = ServiceType.DocumentCapture;
            }
        }));
    };
    AccountService.prototype.isTrialAccount = function () {
        return (this.account.paymentType === 'Trial');
    };
    return AccountService;
}());
export { AccountService };
